import { newAPI } from '../../../services';

export const fetchVehicleDamageList = async (userId, establishmentId, qp) => {
  const url = establishmentId
  ? `${userId}/establishment/${establishmentId}/vehicles/damage/export/json?${qp}`
  : `${userId}/vehicles/damage/export/json?${qp}`;

  const response = await newAPI.get(url);
  return response.data;
}